import AdSide from './AdSide.vue'

export default AdSide
